<template>
	<div>
		<div style="width: 100%;">
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/cooperate/acc.png" style="width: 100%; " />
			<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/cooperate/acc1.png" style="width: 100%;" />
		</div>
		<div style="width: 90%;" class="center_sun">
			
			<h2>{{ $t('lang.Our_customers')}}</h2>
			<hr />
			<img v-show="this.$i18n.locale == 'zh'" src="../../../public/pic/cooperate/kehu.png"  />
			<img v-show="this.$i18n.locale == 'en'" src="../../../public/pic/cooperate/kehu1.png"/>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			activeIndex: '',
			tel:'',
			};
	},
	head(){
		return {
			title :'合作客户_深圳全智能机器人科技有限公司。Cooperation_Shenzhen All Intelligent Technology Co., Ltd.',
			keywords:'机器人代理,硅胶实体娃娃代理,美女机器人厂家,娃娃体验店批发,硅胶实体娃娃哪个牌子好。Agent for Robots,Agent for Silicone Sex Dolls,Robotic Beauty Manufacturer,Sex Dolls Wholesale,Best Brand for Sex Dolls',
			description:'全智能科技（AI-Tech）是深圳全智能机器人科技有限公司[Shenzhen All Intelligent Technology Co.，Ltd. ]的简称，沿革于2013年，创建于2016年8月18日。顾名思义，全智能科技（AI-Tech）是以研发、生产、销售人工智能技术服务和产品的国家级高新技术企业。我们利用自主开发的核心技术，以“虚实结合、软硬兼备”的模式，致力于打造实用型的新型人工智能技术和AI科技共享平台。  AI-Tech short for Shenzhen All Intelligent Technology Co.，Ltd. started in 2013 which is a national level high tech company researching, manufacturing, selling AI services and AI products. We leverage self-developed core technologies,combine services with products,software with hardware, dedicating to creat a sharable platform of new pratical AI technology.',
			};
	},
	methods: {
	// 移入
		mouseOver:function(event) {
			//alert(event.currentTarget.id)
			this.activeIndex = event.currentTarget.id
		},
	// 移出
		mouseLeave:function() {
			this.activeIndex = ''
		},
		onSubmit(){
			if(this.tel == ""){
				alert("请输入电话号码");
			}else{
				this.axios({
					// 默认请求方式为get
					method: 'get',
					//url: 'http://localhost:8080/mail/send_mail',
					url: 'http://www.aitech-cms.com/mail/send_mail',
					// 传递参数
					params: {
						tel: this.tel,
					},
				}).then(response => {
					// 请求成功
					//console.log(JSON.stringify(response));
					let res = response.data.msg;
					//console.log(res);
					this.$router.push({ path: 'regist' })
				}).catch(error => {
					// 请求失败，当then种出错就进入这里
					//console.log("请求失败"+JSON.stringify(error));
					//alert("请求失败");
				});
			}
		},
		handle1:function(){
			document.getElementById("title").innerHTML = this.title;
			document.getElementById("keywords").content = this.keywords;
			document.getElementById("description").content = this.description;
		},
	}
}
</script>

<style scoped>
	p{
		font-size: 15px;
		text-align: justify;/*外部引人入的不生效*/
	}
	.input{
		height: 40px;
		width: 350px;
		font-size: 30px;
	
	}
</style>
